import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class HeaderImageConverter extends CmsConverterService<HeaderImageData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_header_image_normal_title_text?.value
    const altText = formData.st_header_image_normal_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      imageDesktop: CmsConverterService.mapImage(formData.st_header_image_normal_reference, lazyLoad, altText, title),
      imageMobile: CmsConverterService.mapImage(formData.st_header_image_mobile_reference, lazyLoad, altText, title),
      text: formData.st_header_image_normal_text ?? defaultTextInput,
      gradient: {
        name: formData.st_header_image_normal_gradient?.name ?? '',
        value: formData.st_header_image_normal_gradient?.value?.identifier ?? '',
      },
    }
  }
}

export const HEADER_IMAGE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, HeaderImageData>>('HeaderImageConverter')

export interface HeaderImageData extends ConvertedComponentData {
  imageDesktop: Image;
  imageMobile: Image;
  text: TextInput;
  gradient: TextInput;
}
